// @flow
import Auth0 from 'auth0-js'
import { promisifyAll } from 'bluebird'

import config from 'client/config'

type WebAuthType = {
  clientId?: string
}

type CredentialsType = {
  connection: string,
  email: string,
  password: string,
  responseType: string
}

type AuthorizeType = {
  connection: string,
  redirectUri: string,
  responseType: string
}

export default class AuthService {// $FlowFixMe
  auth0: promisifyAll

  constructor(params: WebAuthType = {}) {
    // Configure Auth0
    const auth0 = new Auth0.WebAuth({
      clientID: params.clientId,
      scope: 'openid id login_id user_id email first_name last_name name avatar_url timezone permissions organization_id organization_name organization_trim organization_plan instance_id instance_entrypoint is_external',
      domain: config.auth0Domain,
      audience: config.auth0Audience,
      ...params
    })

    this.auth0 = promisifyAll(auth0)
    this.auth0.client = promisifyAll(this.auth0.client)
    this.auth0.redirect = promisifyAll(this.auth0.redirect)
  }

  loginWithCredentials (params: CredentialsType): any {
    return this.auth0.redirect.loginWithCredentialsAsync(params)
  }

  loginWithAuthorize (params: AuthorizeType): any {
    return this.auth0.authorizeAsync(params)
  }

  parseHash (hash: string): any {
    return this.auth0.parseHashAsync({ hash })
  }

  getOauthToken (client, queryString): any {
    const params = new URLSearchParams(queryString)
    const code = params.get("code")
    console.log('Params', queryString, params, code)
    return this.auth0.client.oauthTokenAsync({ grantType: 'authorization_code',
      code: code,
      redirectUri: client.redirectUri
    })
  }
}
